import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50">
            {article.categoryName}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 font-heading">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}